import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL_SANDBOX, GET_TAX_DETAIL } from '../../../Constants/Config';

const initialState = {
  loading: false,
  taxDetailData: [],
  successMessage: '',
  error: '',
  requestKey: null,
  activeRequestKey: null,
  activeRequestId: null,
};

export const createTaxDetailRequestKey = (data) => {
  const merchantId = String(data?.merchant_id ?? '').trim().toUpperCase();
  return merchantId ? `merchant:${merchantId}` : '';
};

export const fetchTaxDetailData = createAsyncThunk(
  'taxDetail/fetchWishlistData',
  async (data) => {
    try {
      const response = await axios.post(
        BASE_URL_SANDBOX + GET_TAX_DETAIL,
        data,
        { headers: { 'Content-Type': 'multipart/form-data' } },
      );
      if (response.data.status === 200) {
        return {
          message: response.data.message,
          result: response.data?.result,
        };
      }
      return undefined;
    } catch (error) {
      throw new Error(
        error?.response?.data?.message ||
          error?.message ||
          'Unable to retrieve tax details',
      );
    }
  },
);

const taxDetailSlice = createSlice({
  name: 'taxDetail',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchTaxDetailData.pending, (state, action) => {
      const requestKey = createTaxDetailRequestKey(action.meta?.arg);
      if (state.requestKey !== requestKey) {
        state.taxDetailData = [];
        state.requestKey = null;
      }
      state.loading = true;
      state.error = '';
      state.activeRequestKey = requestKey;
      state.activeRequestId = action.meta?.requestId || null;
    });
    builder.addCase(fetchTaxDetailData.fulfilled, (state, action) => {
      const requestKey = createTaxDetailRequestKey(action.meta?.arg);
      if (
        state.activeRequestId !== action.meta?.requestId ||
        state.activeRequestKey !== requestKey
      ) {
        return;
      }

      state.loading = false;
      state.taxDetailData = action.payload?.result;
      state.successMessage = action.payload?.message;
      state.requestKey = requestKey || null;
      state.activeRequestKey = null;
      state.activeRequestId = null;
      state.error = '';
    });
    builder.addCase(fetchTaxDetailData.rejected, (state, action) => {
      const requestKey = createTaxDetailRequestKey(action.meta?.arg);
      if (
        state.activeRequestId !== action.meta?.requestId ||
        state.activeRequestKey !== requestKey
      ) {
        return;
      }

      state.loading = false;
      state.taxDetailData = {};
      state.requestKey = null;
      state.activeRequestKey = null;
      state.activeRequestId = null;
      state.error = action.error?.message || 'Unable to retrieve tax details';
    });
  },
});

export default taxDetailSlice.reducer;
